export let wednesdayAbbreviatedLowercase = "SJIIib";
export default {wednesdayAbbreviatedLowercase};